// extracted by mini-css-extract-plugin
module.exports = {"requiredPanel":"styles_requiredPanel__TePJ8"};